<!-- COMMENTS TAB CONTENT Starts -->
<div class="comments-tab-content commentsScrollableContainer" (scroll)="this.onScrollDown($event)" >
  <!-- Comments row starts -->
  @if (fileInfoImpl.fileInfoCommentsData.length==0 && isCommentLoaded==true) {
    <div class='empty-comments'>
    No comments yet</div>
  }
  @for (comment of fileInfoImpl.fileInfoCommentsData; track comment; let i = $index) {
    <div  class="comments-inner" id="{{'comment-row-'+i}}">
      <!-- Activity row strats -->
      <div class="row ml-0 mt-0 mr-0 mb-2 pl-0 pt-0 pr-0 pb-0">
        <div class="col-2 pl-0 pt-0 pr-1 pb-0">
          <!-- DP -->
          <div class="dp">
            <span class="icon-profile-holder NeueUserFilled mr-2"></span>
            <img [ngStyle]="{'background-size':'100%','background-image': attachKeysToPhoto(comment.profilePhotoPath)}" alt="" class="img-fluid" />
          </div>
        </div>
        <div class="col-8 pl-1 pl-lg-0 pt-0 pr-0 pb-0">
          <div class="middle-col">
            <h2>{{comment.firstName}}&nbsp;{{comment.lastName}}</h2>
            <div class="message">
              <p>{{comment.comment}}</p>
            </div>
          </div>
        </div>
        <div class="col-2 pl-0 pt-0 pr-0 pb-0 text-right">
          @if (comment.canDelete) {
            <span class="NeueRemove" (click)="deleteFileInfoComment(comment.commentKey, i)"></span>
          }
          <span class="time">
            {{universalService.showTimeInFormat(comment.createdDate, textToAppend, fileInfoImpl.currentTimeToUse)}}
          </span>
        </div>
      </div>
    </div>
  }
  <!-- Comments row ends -->

  <!-- MESSAGE BOX Starts -->
  @if (isAllowedToComment==true) {
    <div class="message-input-box-main">
      <!-- dp -->
      <span class="NeueUserFilled mr-2"></span>
      <img [ngStyle]="{'background-size':'100%','background-image': getProfileImageUrl()}" alt="" class="img-fluid" />
      <input type="text" class="msg" id="comment-input-box" placeholder="Say Something" maxlength="200" [(ngModel)]="userComment"/>
      <!-- Send -->
      <span class="NeueSendFilled" (click)="addFileInfoComment()" [ngClass]="[userComment == '' || isCommentAdded == false ? 'div-disabled' : '']" ></span>
    </div>
  }
  <!-- MESSAGE BOX Ends -->

</div>
<!-- COMMENTS TAB CONTENT Ends -->
